import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';

import Modal, { ModalContainer } from '~/components/modal';
import LoadingSpinner from '../../loadingSpinner';
import { numberFormat } from '~/common';

import './BetsSellingModal.scss';

@inject('accountStore', 'dictStore')
@observer
export default class BetsSellingModal extends Component {
  onCloseModal = () => {
    this.props.accountStore.openBetSellModal(false);
  };

  componentWillUnmount() {
    this.props.accountStore.resetSelling();
  }

  render() {
    const { step, wait } = this.props.accountStore.sellingStatus;

    return (
      <ModalContainer>
        <Modal
          show={true}
          onCloseModal={this.onCloseModal}
          styleModal={step === 2 ? { width: '290px', height: '150px' } : { width: '376px' }}
        >
          {
            wait
              ? <LoadingSpinner />
              : <Fragment>
                {step === 1 ? <BetsSellingModalStep1 onCloseModal={this.onCloseModal} /> : null}
                {step === 2 ? <BetsSellingModalStep2 /> : null}
              </Fragment>
          }
        </Modal>
      </ModalContainer>
    );
  }
}

@inject('accountStore', 'dictStore', 'appStore')
@observer
class BetsSellingModalStep1 extends Component {

  sellBet = () => {
    const { activeBetData, activeBetSellingData } = this.props.accountStore;
    this.props.accountStore.sellBet(activeBetData.wager_id, activeBetSellingData.price);
  };

  render() {
    const { getLang } = this.props.dictStore;
    const { activeBetData, activeBetSellingData, sellingStatus, result } = this.props.accountStore;
    return (
      <Fragment>
        <div className="bet-sale-modal__body">
          <div className="type">
            <p className="basket-bets-item-name fl_l">
              {getLang('BET_SINGLE')} {`#${activeBetData.number}`}
            </p>
          </div>
          <div className="question question_big">{getLang('SELL_BET')}</div>
          <div className="question">
            {activeBetData.games[0].event}
          </div>
          <div className="question question_big question_sum">за {activeBetSellingData.price} &#8381;?</div>
          <div className="data">
            {getLang('BET_AMOUNT')} {numberFormat(activeBetData.amount_set, 2, '.', ' ')} {this.props.appStore.currency.name}
          </div>
          <div className="data">
            {getLang('COEFFICIENT')} {numberFormat(!activeBetData.games[0].cf || activeBetData.games[0].cf == 0 ? '' : activeBetData.games[0].cf, 2, ',', ' ',)}
          </div>
          {!sellingStatus.success && <div className="result-message result-message_error">
            {result.text}
          </div>}
        </div>
        <div className="bet-sale-modal__buttons">
          <button
            type="button"
            tabIndex="2"
            className="flat_button flat_button_2"
            onClick={this.props.onCloseModal}
          >
            {getLang('CANCEL1')}
          </button>
          {
            !sellingStatus.isBlockedSell && <button
              type="button"
              tabIndex="2"
              className="flat_button flat_button_1"
              onClick={this.sellBet}>
              {getLang('SELL')}
            </button>
          }
        </div>
      </Fragment>
    );
  }
}

@inject('accountStore', 'dictStore')
@observer
class BetsSellingModalStep2 extends Component {
  render() {
    const { getLang } = this.props.dictStore;
    const { result } = this.props.accountStore;
    return (
      <Fragment>
        <div className="bet-sale-modal__body">
          <div className="question question_big">{getLang('READY')}</div>
          <div className="logo_success" />
          <div className="result-message">
            {result.text}
          </div>
        </div>
      </Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/account/BetsSellingModal/index.js